import InvoiceSearchResultsHtml  from '../../app-lite/invoices/templates/invoice.search-results.html';
import MechanicSearchResultsHtml from './templates/mechanic.search.results.html';

export function MechanicClockOnCtrl (
  $state,
  $scope,
  messages,
  streamSearch,
  workshopAPI
) {

  $scope.invoiceSearchResultsTemplateUrl  = InvoiceSearchResultsHtml;
  $scope.mechanicSearchResultsTemplateUrl = MechanicSearchResultsHtml;

  $scope.invoiceSearch = {
    list: [],
    selected: {
      id: '',
      display_name: ''
    },
    search (typed) {
      return streamSearch.search('invoices', typed)
      .then(data => $scope.invoiceSearch.list.concat(data));
    },
    choose (invoice) {
      this.selected  = invoice;

      $scope.invoice = invoice;

      if ($scope.invoice.vehicle_id) {
        workshopAPI.get('/vehicle', $scope.invoice.vehicle_id).then(vehicle => {
          $scope.vehicle = vehicle;
        });
      };

    },
    format (invoice) {
      return invoice ? invoice.job_card_number: '';
    }
  };

  $scope.mechanicSearch = {
    list: [],
    search (typed) {
      return streamSearch.search('mechanics', typed)
      .then(mechanics => this.list.concat(mechanics));
    },
    format (mechanic) {
      return angular.isObject(mechanic) ? mechanic.display_name : mechanic;
    },
    choose (mechanic) {
      $scope.mechanic = mechanic;

      if ($scope.count === 1) {
        $scope.clockMechanic();
      }
    }
  };

  $scope.findLabourItems = function () {
    if ($scope.invoice) {
      workshopAPI.get('/invoices/labor_items_on_invoice', $scope.invoice.id)
      .then(labour_items => {
        $scope.count = labour_items.length;

        if ($scope.count > 1) {
          $scope.labor_items = labour_items;
        }
        else if ($scope.count == 1) {
          $scope.labor_item = labour_items[0];
        }
        else {
          messages.show('There are no labour lines on this invoice. Cannot clock on or off this invoice.', 'error');
        };
      });
    }
  };

  $scope.clockMechanic = function() {
    if ($scope.labor_item && $scope.mechanic && $scope.invoice) {
      const item = {
        invoice_item_id : $scope.labor_item.id,
        mechanic_id : $scope.mechanic.id,
        invoice_id: $scope.invoice.id
      };

      if (item.invoice_item_id && item.mechanic_id && item.invoice_id) {
        workshopAPI.post('/labor_items/update_mechanic_time_on_invoice', item, 'clock_on_item')
        .then(result => {
          messages.show(`${ $scope.mechanic.display_name } clocked ${ result.process === 'start' ? 'onto' : 'off of' } Job No. ${ $scope.invoice.job_card_number }`, 'success');

          $state.reload();
        });
      }
    };
  };

};